class Bem {
  constructor(block) {
    this.block = (...modifiers) => {
      return this.modifiers(this._block)(...modifiers);
    };
    this.element = (element) => {
      return this.modifiers(`${this._block}__${element}`);
    };
    this.modifiers = (blockElement) => {
      return function createBem(...modifiers) {
        const bemModifiers = modifiers.filter(Boolean).map((modifier) => `${blockElement}--${modifier}`);
        return [blockElement, ...bemModifiers].join(" ").toLowerCase();
      };
    };
    this.concat = (className) => {
      if (className) {
        return `${this._block} ${className}`;
      }
      return this._block;
    };
    this._block = block;
  }
  static create(block) {
    return new Bem(block);
  }
}
function isValidLength(length) {
  const constantValues = "(fit|min|max)-content|auto|0";
  const number = "[+-]?\\d{1,10}\\.?\\d{0,10}";
  const units = ["px", "cm", "mm", "Q", "in", "pc", "pt", "ch", "em", "rem", "ex", "ic", "%"].join("|");
  const viewportUnits = "[sld]?v(h|w|max|min|b|i)";
  const cssLengthRegex = RegExp(`^(${constantValues})$|^${number}(${units}|${viewportUnits})$`, "g");
  return cssLengthRegex.test(length);
}
function addClass(...params) {
  return params.filter(Boolean).reduce((acc, next) => {
    acc.push(next);
    return acc;
  }, []).join(" ");
}

export { Bem, addClass, isValidLength };
